import { NgModule } from '@angular/core';
import { ZefTranslationsService } from '@zerops/zef/translations';
import { FEATURE_NAME } from './shared-ipv4.constant';

const en = {
  enableText: 'Including shared IPv4 into CNAME will affect all existing and new domains. <br />Before making this change, ensure that any domains using CNAME records will work with the shared IPv4 address (for example Cloudflare required only IPv6 to work).',
  disableText: 'Excluding shared IPv4 from CNAME will affect all existing and new domains. <br />Before making this change, ensure that any domains using CNAME records either do not rely on IPv4 or can operate with IPv6 only (as in the case of Cloudflare).'
};

export type SharedIPv4Translations = typeof en;

@NgModule()
export class SharedIPv4TranslationsModule {
  constructor(private _translationsService: ZefTranslationsService) {
    this._translationsService.setTranslations(FEATURE_NAME, { en });
  }
}
